import { Common } from './common.model';
export { ApiBind } from './common.model';

export abstract class CommonSearchParam extends Common {

  constructor() {
    super();
  }

  /**
   * URLのクエリパラメータ文字を返却する。
   *
   * パラメータの値の型がArray型の場合、param_key=value1,value2
   * といた文字列が生成される。
   *
   * @returns URLのクエリパラメータ文字列
   */
  public toURLQuery(): string {
    const json = this.toJSON();
    return Object.keys(json)
      .filter(k => json[k] != null)
      .reduce((prev, k) => prev += '&' + k + '=' + encodeURIComponent(json[k]), '')
      .replace('&', '?');
  }

  /**
   * URLのクエリパラメータ文字を返却する。
   *
   * パラメータの値の型がArray型の場合、param_key=value1&param_key=value2
   * といた文字列が生成される。
   *
   * @returns URLのクエリパラメータ文字列
   */
  public toFlattenURLQuery(): string {
    const obj = this.toJSON();
    const params = new URLSearchParams();
    Object.keys(obj).filter((k) => obj[k] != null)
    .forEach((k) => {
      const value = obj[k];
      if (Array.isArray(value)) {
        value.forEach((v) => params.append(k, v));
      } else {
        params.append(k, value);
      }

    });
    return '?'+params.toString();
  }

}
